import { render } from "./LoadingSpin.vue?vue&type=template&id=78bc823c&ts=true"
import script from "./LoadingSpin.vue?vue&type=script&lang=ts"
export * from "./LoadingSpin.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__